const defaultInputConfig = {
  type: "input",
  inputType: "text",
};

export const fieldUser = [
  {
    id: "firstName",
    name: "firstName",
    label: "First Name",
  },
  {
    id: "lastName",
    name: "lastName",
    label: "Last Name",
  },
  {
    id: "emailAddress",
    name: "emailAddress",
    label: "Email Address",
  },
  {
    id: "phoneNumber",
    name: "phoneNumber",
    label: "Phone Number",
  },
  {
    id: "alternatePhoneNumber",
    name: "alternatePhoneNumber",
    label: "Alternate Phone Number",
  },
  {
    id: "billingAddress",
    name: "billingAddress",
    label: "Billing Address",
  },
].map((field) => ({
  ...defaultInputConfig,
  ...field,
}));